module.exports = __webpack_public_path__ + "static/img/20011 (4).b3a4cb0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20011 (4).webp
// module id = lPhv
// module chunks = 14